import { Point, StencilType } from "./frame-stencil";
import {
  BallActionLineType,
  HandoffActionLineType,
  PlayerActionLineType,
  PossessionActionLineType,
} from "./generic-action-line-type";

/** ================================
 * Base
 ================================ */
export enum ActionType {
  PLAYER = "PLAYER",
  BALL = "BALL",
  HANDOFF = "HANDOFF",
  POSSESSION = "POSSESSION",
}

export enum PointType {
  START = "START",
  END = "END",
  ANGLE = "ANGLE",
  CURVE = "CURVE",
  SHADE_VERTEX = "SHADE_VERTEX",
}

export interface MidPoint extends Point {
  pointType: PointType;
}

export interface ActionBase {
  id: string;
  pos: Point;
  stencilType: StencilType.ACTION;
  endPos: Point;
  midPoints: MidPoint[];
  startTime: number;
  endTime: number;
  color?: string;
  rotate?: number;
}

/** ================================
 * Actions
 ================================ */
// Player Action
export interface PlayerActionBase<TActionLine extends PlayerActionLineType = PlayerActionLineType> extends ActionBase {
  actionType: ActionType.PLAYER;
  layerType: TActionLine;
  nextPlayerAction: string | null;
}

// Ball Action
export interface BallActionBase<TActionLine extends BallActionLineType = BallActionLineType> extends ActionBase {
  actionType: ActionType.BALL;
  layerType: TActionLine;
  nextBallAction: string | null;
  nextPlayer: string | null;
  prevPlayer: string | null;
  playerActionStart: string | null;
  playerActionEnd: string | null;
}

export interface HandoffActionBase<TActionLine extends HandoffActionLineType = HandoffActionLineType>
  extends ActionBase {
  actionType: ActionType.HANDOFF;
  layerType: TActionLine;
  prevPlayer: string | null;
  nextPlayer: string | null;
  prevAction: string | null;
  nextAction: string | null;
  startPos: Point;
}

export interface PossessionActionBase<TActionLine extends PossessionActionLineType = PossessionActionLineType>
  extends ActionBase {
  actionType: ActionType.POSSESSION;
  layerType: TActionLine;
  nextPlayerAction: string | null;
  nextBallAction: string | null;
}
